import React, { useEffect, useRef } from "react";
import MyButton from "../../components/MyButton";
import { DataGrid, GridRowsProp, GridColDef } from '@mui/x-data-grid';
import { setDataToModal, setShowAuctionSubmitModal, setShowResultModal } from "../../actions/modal";
import { store } from "../..";
import { useSelector } from "react-redux";
import { eventAuctionSubmitBus, isNotNull } from "../../common/utils";
import { restPostApi, restPostNotShowLoadingApi } from "../../services/httpService";
import { auctionSubmitUrl, buyTurnConfirmUrl, loadInitAuctionUrl } from "../../common/url";
import { error, httpSuccess, success } from "../../common/errorCode";
import { useTranslation } from "react-i18next";


const PlayAction = ({ termInfo, auctionItems, auctionUsers }) => {
    const [auctionUsersUpdate, setAuctionUsersUpdate] = React.useState(auctionUsers);
    // const [loopToGetData, setLoopToGetData] = React.useState(true);
    const { t } = useTranslation();

    var loopToGetData = true;
    // let modalReducer = useSelector((state) => state.ModalReducer);
    const tokenInfo = useSelector((state) => state.SessionReducer);

    const { innerWidth: width, innerHeight: height } = window;

    // console.log("modalReducer PlayAction: " + JSON.stringify(modalReducer));

    console.log("windowWidth: " + width);

    let col1Width = (width - 20) * 0.5;
    let col2Width = (width - 20) * 0.25;
    let col3Width = (width - 20) * 0.25;
    const rows = [];

    for (let i = 0; i < auctionUsersUpdate.length; i++) {
        // convert time to string
        // let dateConvert = new Date(
        //     auctionUsersUpdate[i].auctionTime[0],
        //     auctionUsersUpdate[i].auctionTime[1],
        //     auctionUsersUpdate[i].auctionTime[2],
        //     auctionUsersUpdate[i].auctionTime[3],
        //     auctionUsersUpdate[i].auctionTime[4],
        //     auctionUsersUpdate[i].auctionTime[5]);
        // console.log("dateConvert: " + dateConvert);
        // let hour = dateConvert.getHours() < 10 ? "0" + dateConvert.getHours() : dateConvert.getHours();
        // let min = dateConvert.getMinutes() < 10 ? "0" + dateConvert.getMinutes() : dateConvert.getMinutes();
        // let sec = dateConvert.getSeconds() < 10 ? "0" + dateConvert.getSeconds() : dateConvert.getSeconds();

        let dateSeprate = auctionUsersUpdate[i].time.split(" ");
        rows.push({
            id: i,
            col1: auctionUsersUpdate[i].msisdn,
            col2: dateSeprate[1],
            col3: auctionUsersUpdate[i].value + " " + auctionUsersUpdate[i].type
        },)
    }

    const columns = [
        { field: 'col1', headerName: t("phoneNumber"), width: col1Width },
        { field: 'col2', headerName: t("time"), width: col2Width },
        { field: 'col3', headerName: t("auction"), width: col3Width },

    ];

    let modalSubmitIsOpen = false;
    function openBoxToSubmit() {
        store.dispatch(setShowAuctionSubmitModal(!modalSubmitIsOpen));
    }



    useEffect(() => {
        // stop loading data
        // loadUserAuctionRealtime(false);
        setTimeout(() => {
            loadUserAuctionRealtime();
        }, 10000);
        return () => {
            console.log("PLAY TERMINATED");
            // setLoopToGetData(false);
            loopToGetData = false;
        }
    }, []);

    async function loadUserAuctionRealtime() {
        console.log("loopToGetData: " + loopToGetData);

        let res = await restPostNotShowLoadingApi(
            loadInitAuctionUrl,
            {
                pageSize: 10,
                pageNumber: 0
            },
            tokenInfo
        );
        console.log("res: " + JSON.stringify(res));

        if (res != null) {
            console.log("status: " + res.status);

            let message = "Success";
            if (res.status === httpSuccess) {
                console.log("errorCode: " + res.data.errorCode);
                if (res.data.errorCode === success) {
                    if (isNotNull(res.data.data.termInfo)) {
                        setAuctionUsersUpdate(res.data.data.auctionUsers);
                        if (isNotNull(loopToGetData) && loopToGetData === true) {
                            setTimeout(() => {
                                loadUserAuctionRealtime();
                            }, 5000);
                        }
                    } else {
                        store.dispatch(setDataToModal({
                            type: 'result',
                            dataToModal: {
                                errorCode: res.data.errorCode,
                                message: res.data.message
                            }
                        }));
                    }
                } else {
                    store.dispatch(setDataToModal({
                        type: 'result',
                        dataToModal: {
                            errorCode: res.data.errorCode,
                            message: res.data.message
                        }
                    }));
                }
            } else {
                console.log("message: " + JSON.stringify(res.data));
                message = res.data + ""
                store.dispatch(setDataToModal({
                    type: 'result',
                    dataToModal: {
                        errorCode: res.data.errorCode,
                        message: message
                    }
                }));
            }
        } else {
            console.log("message: Exception");
            store.dispatch(setDataToModal({
                type: 'result',
                dataToModal: {
                    errorCode: error,
                    message: "Exception An error was happened !"
                }
            }));
        }
    }

    return (
        <div>
            <div className='frame-time-container'>
                <div className='frame-time-box'>
                    {t("frameTime").toUpperCase()}
                </div>

                <div className='frame-time-detail'>
                    <div className='frame-time-day'>
                        {termInfo.dateRun}
                    </div>
                    <div className='frame-time-day'>
                        {termInfo.fromTime} - {termInfo.toTime}
                    </div>
                </div>
            </div>

            <div className="auction-container">
                <div className="auction-prize">
                    {auctionItems[0].name}
                </div>

                <div className="image-prize">
                    <img src={"https://u-win.la/assets/images/" + auctionItems[0].image} />
                </div>

                <div className="auction-des">
                    {t("ruleBidder")}
                </div>

                <div style={{ margin: "10px" }}>
                    <MyButton name={t("auctionNow")} onClickButton={() => openBoxToSubmit()} />
                </div>
                <div style={{ marginTop: "20px" }}>
                    <DataGrid
                        disableColumnMenu
                        rows={rows}
                        columns={columns}
                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 5 },
                            },
                        }}
                        style={{ color: "white", border: "none" }}
                        sx={{
                            color: "white",
                            '& .MuiDataGrid-cell:hover': {
                                color: 'white',
                            },
                            '& .MuiTablePagination-displayedRows': {
                                color: 'white',
                            },
                            '& .MuiButtonBase-root': {
                                color: 'white !important',
                            },
                        }}
                    />
                </div>

            </div>
        </div>
    );
}

export default PlayAction;